import { SWRConfig } from 'swr'
import { ReactNode } from 'react'

interface SWRProviderProps {
  children: ReactNode
}

export function SWRProvider({ children }: SWRProviderProps) {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        dedupingInterval: 30000,
        revalidateOnMount: true,
        focusThrottleInterval: 300000,
        errorRetryCount: 2,
        revalidateOnReconnect: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}
